import DashboardPanel from './DashboardPanel';

export default DashboardPanel;
